import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { LangProvider } from "@/i18n";
import Hub from "@/pages/Hub";
import FcLayout from "@/pages/fc/FcLayout";
import FcHome from "@/pages/fc/FcHome";
import SportHome from "@/pages/fc/SportHome";
import SportWedstrijden from "@/pages/fc/SportWedstrijden";
import FcInschrijven from "@/pages/fc/FcInschrijven";
import PaymentReturn from "@/pages/fc/FcPaymentReturn";
import FcShop from "@/pages/fc/FcShop";
import FcPloegen from "@/pages/fc/FcPloegen";
import JeugdLayout from "@/pages/jeugd/JeugdLayout";
import JeugdHome from "@/pages/jeugd/JeugdHome";
import JeugdPage from "@/pages/jeugd/JeugdPage";
import JeugdInschrijven from "@/pages/jeugd/JeugdInschrijven";
import JeugdGalerij from "@/pages/jeugd/JeugdGalerij";
import Admin from "@/pages/Admin";

function App() {
  useEffect(() => {
    const TITLE = "Inkad Diegem — FC Inkad & Inkad Jeugd";
    document.title = TITLE;
    const obs = new MutationObserver(() => {
      if (document.title !== TITLE) document.title = TITLE;
    });
    const titleEl = document.querySelector("title");
    if (titleEl) obs.observe(titleEl, { childList: true });
    return () => obs.disconnect();
  }, []);
  return (
    <div className="App">
      <LangProvider>
        <BrowserRouter>
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<Hub />} />

              <Route path="/beheer" element={<Admin />} />

              <Route path="/fc-inkad" element={<FcLayout />}>
                <Route index element={<FcHome />} />
                <Route path="futsal" element={<SportHome sport="futsal" />} />
                <Route path="futsal/wedstrijden" element={<SportWedstrijden sport="futsal" />} />
                <Route path="veldvoetbal" element={<SportHome sport="football" />} />
                <Route path="veldvoetbal/wedstrijden" element={<SportWedstrijden sport="football" />} />
                <Route path="inschrijven" element={<FcInschrijven />} />
                <Route path="inschrijven/betaling" element={<PaymentReturn branch="fc-inkad" />} />
                <Route path="ploegen" element={<FcPloegen />} />
                <Route path="clubshop" element={<FcShop />} />
                <Route path="minis" element={<Navigate to="/fc-inkad/veldvoetbal" replace />} />
                <Route path="veteranen" element={<Navigate to="/fc-inkad/veldvoetbal" replace />} />
                <Route path="wedstrijden" element={<Navigate to="/fc-inkad/futsal/wedstrijden" replace />} />
              </Route>

              <Route path="/jeugd" element={<JeugdLayout />}>
                <Route index element={<JeugdHome />} />
                <Route path="activiteiten" element={<JeugdPage page="activiteiten" />} />
                <Route path="huiswerkklas" element={<JeugdPage page="huiswerkklas" />} />
                <Route path="vakantiekampen" element={<JeugdPage page="vakantiekampen" />} />
                <Route path="liefdadigheid" element={<JeugdPage page="liefdadigheid" />} />
                <Route path="galerij" element={<JeugdGalerij />} />
                <Route path="inschrijven" element={<JeugdInschrijven />} />
                <Route path="inschrijven/betaling" element={<PaymentReturn branch="jeugd" />} />
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AnimatePresence>
        </BrowserRouter>
      </LangProvider>
    </div>
  );
}

export default App;
